/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: barcode was not present
 * @export
 * @interface PaxCheckNoBarcodeScannedError
 */
export interface PaxCheckNoBarcodeScannedError {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckNoBarcodeScannedError
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckNoBarcodeScannedError interface.
 */
export function instanceOfPaxCheckNoBarcodeScannedError(value: object): value is PaxCheckNoBarcodeScannedError {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckNoBarcodeScannedErrorFromJSON(json: any): PaxCheckNoBarcodeScannedError {
    return PaxCheckNoBarcodeScannedErrorFromJSONTyped(json, false);
}

export function PaxCheckNoBarcodeScannedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckNoBarcodeScannedError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckNoBarcodeScannedErrorToJSON(json: any): PaxCheckNoBarcodeScannedError {
    return PaxCheckNoBarcodeScannedErrorToJSONTyped(json, false);
}

export function PaxCheckNoBarcodeScannedErrorToJSONTyped(value?: PaxCheckNoBarcodeScannedError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

